import type * as SchemaTypes from '../types';

import type { UserPreviewDataFragment } from './UserPreviewData';
import { gql } from '@apollo/client';
import { UserPreviewDataFragmentDoc } from './UserPreviewData';
export type MobilityLocationDataFragment = (
  { __typename: 'MobilityLocation' }
  & Pick<SchemaTypes.MobilityLocation, 'id' | 'name' | 'address' | 'url' | 'phone' | 'email' | 'moduleId' | 'moduleName' | 'assigneeId' | 'isHomeDelivery'>
  & { assignee?: SchemaTypes.Maybe<(
    { __typename: 'User' }
    & UserPreviewDataFragment
  )> }
);

export const MobilityLocationDataFragmentDoc = /*#__PURE__*/ gql`
    fragment MobilityLocationData on MobilityLocation {
  id
  name
  address
  url
  phone
  email
  moduleId
  moduleName
  assigneeId
  assignee {
    ...UserPreviewData
  }
  isHomeDelivery
}
    `;